import React, { useState, useEffect } from 'react';
import { supabase } from '../supabase';
import AudienciasPanel from './AudienciasPanel';
import VencimientosPanel from './VencimientosPanel';
import TareasPanel from './TareasPanel';
import HistorialPanel from './HistorialPanel';
import TareaDetalle from '../components/TareaDetalle';
import EventoDetalle from '../components/EventoDetalle';
import EventoModal from '../components/EventoModal';
import ExpedienteDetalle from './ExpedienteDetalle';
import TramiteDetalle from './TramiteDetalle';
import { localToday } from '../utils/dateUtils';
import { emitTareaChanged, onTareaChanged } from '../utils/tareasBus';
import { onEntidadChanged } from '../utils/entidadBus';
import { onDataChanged } from '../utils/dataBus';
import ClienteModal from '../components/ClienteModal';
import ClienteDetalle from './ClienteDetalle';
import ExpedienteNuevoModal from '../components/ExpedienteNuevoModal';
import TramiteNuevoModal from '../components/TramiteNuevoModal';
import TareaModal from '../components/TareaModal';

const today = localToday();
const formatHora = (h) => h ? h.substring(0, 5) : null;

const colorTipo = (tipo) => {
  const map = { 'Audiencia': '#0d9488', 'Consulta / Turno': '#0891b2', 'Reunión': '#4f46e5', 'Vencimiento procesal': '#ea580c', 'Vencimiento de deuda': '#ea580c' };
  return map[tipo] || '#9ca3af';
};

function Section({ title, count, children, defaultOpen = true, accentColor }) {
  const [open, setOpen] = useState(defaultOpen);
  return (
    <div style={{ border: '1px solid var(--border2)', borderRadius: 10, overflow: 'hidden' }}>
      <div onClick={() => setOpen(v => !v)}
        style={{ padding: '10px 16px', background: 'var(--surface2)', display: 'flex', alignItems: 'center', gap: 10, cursor: 'pointer', userSelect: 'none', borderBottom: open ? '1px solid var(--border2)' : 'none' }}>
        {accentColor && <div style={{ width: 3, height: 14, borderRadius: 2, background: accentColor, flexShrink: 0 }} />}
        <span style={{ fontSize: 12, fontWeight: 700, color: 'var(--text)', textTransform: 'uppercase', letterSpacing: 0.5 }}>{title}</span>
        {count != null && <span style={{ fontSize: 11, color: 'var(--text4)', background: 'var(--surface)', border: '1px solid var(--border2)', borderRadius: 10, padding: '0 7px' }}>{count}</span>}
        <span style={{ fontSize: 11, color: 'var(--text4)', marginLeft: 'auto' }}>{open ? '▼' : '▶'}</span>
      </div>
      {open && <div style={{ padding: '12px 16px' }}>{children}</div>}
    </div>
  );
}

export default function EspacioDeTrabajo({ onNavigate }) {
  const [audienciasHoy,        setAudienciasHoy]        = useState([]);
  const [tareasHoy,            setTareasHoy]            = useState([]);
  const [vencimientosHoy,      setVencimientosHoy]      = useState([]);
  const [vencimientosEvHoy,    setVencimientosEvHoy]    = useState([]);
  const [proximaAudiencia,     setProximaAudiencia]     = useState(null);
  const [proximoVencimiento,   setProximoVencimiento]   = useState(null);
  const [loading,              setLoading]              = useState(true);
  const [tareasPendientesCount, setTareasPendientesCount] = useState(0);

  // drawers y modales
  const [tareaModal,         setTareaModal]         = useState(null);
  const [tareaEdit,          setTareaEdit]          = useState(null);
  const [seguimientoVinculo, setSeguimientoVinculo] = useState(null);
  const [verExpediente,      setVerExpediente]      = useState(null);
  const [verTramite,         setVerTramite]         = useState(null);
  const [verCliente,         setVerCliente]         = useState(null);
  const [clienteEdit,        setClienteEdit]        = useState(null);
  const [eventoDetalle,      setEventoDetalle]      = useState(null);
  const [eventoEdit,         setEventoEdit]         = useState(null);
  const [drawerAudiencias,   setDrawerAudiencias]   = useState(false);
  const [drawerVencimientos, setDrawerVencimientos] = useState(false);
  const [drawerTareas,       setDrawerTareas]       = useState(false);
  const [drawerHistorial,    setDrawerHistorial]    = useState(false);
  const [modalNuevoCliente,  setModalNuevoCliente]  = useState(false);
  const [modalNuevoExpTram,  setModalNuevoExpTram]  = useState(false);
  const [nuevoExpTramTipo,   setNuevoExpTramTipo]   = useState(null); // 'expediente' | 'tramite'
  const [modalNuevoEvento,   setModalNuevoEvento]   = useState(false);
  const [modalNuevaTarea,    setModalNuevaTarea]    = useState(false);
  const [buscarTarea,        setBuscarTarea]        = useState('');

  async function fetchHoy() {
    setLoading(true);
    const [{ data: evs }, { data: vencsEv }, { data: tar }, { data: vencs }, { data: proxAud }, { data: proxVenc }] = await Promise.all([
      supabase.from('agenda')
        .select('*, clientes(nombre, apellido), expedientes(numero, caratula)')
        .eq('fecha', today).eq('estado', 'pendiente').eq('eliminado', false)
        .not('tipo', 'in', '("Vencimiento procesal","Vencimiento de deuda")')
        .order('hora', { ascending: true, nullsFirst: false }),
      supabase.from('agenda')
        .select('*, clientes(nombre, apellido), expedientes(numero, caratula)')
        .eq('fecha', today).eq('estado', 'pendiente').eq('eliminado', false)
        .in('tipo', ['Vencimiento procesal', 'Vencimiento de deuda'])
        .order('hora', { ascending: true, nullsFirst: false }),
      supabase.from('tareas')
        .select('*, expedientes(caratula, numero, expedientes_clientes(clientes(nombre, apellido))), tramites(nombre, tramites_clientes(clientes(nombre, apellido)))')
        .eq('completada', false).eq('descartada', false).eq('eliminado', false)
        .eq('fecha', today)
        .order('fijada', { ascending: false }),
      supabase.from('tareas')
        .select('*, expedientes(caratula, numero), tramites(nombre)')
        .eq('completada', false).eq('descartada', false).eq('eliminado', false)
        .eq('fecha_vencimiento', today)
        .order('fijada', { ascending: false }),
      supabase.from('agenda')
        .select('id, titulo, fecha, hora, tipo')
        .eq('estado', 'pendiente').eq('eliminado', false)
        .gt('fecha', today)
        .order('fecha', { ascending: true })
        .order('hora', { ascending: true, nullsFirst: false })
        .limit(1),
      supabase.from('tareas')
        .select('id, titulo, fecha_vencimiento')
        .eq('completada', false).eq('descartada', false).eq('eliminado', false)
        .not('fecha_vencimiento', 'is', null)
        .gt('fecha_vencimiento', today)
        .order('fecha_vencimiento', { ascending: true })
        .limit(1),
    ]);
    setAudienciasHoy(evs || []);
    setVencimientosEvHoy(vencsEv || []);
    setTareasHoy(tar || []);
    setVencimientosHoy(vencs || []);
    setProximaAudiencia(proxAud?.[0] || null);
    setProximoVencimiento(proxVenc?.[0] || null);
    setLoading(false);
  }

  useEffect(() => { fetchHoy(); }, []);

  // Mantenerse sincronizado cuando una tarea cambia desde cualquier otro lugar
  // (un drawer de expediente/trámite, otro panel, etc.)
  useEffect(() => onTareaChanged(() => fetchHoy()), []);

  // Idem cuando se crea/edita/elimina un expediente, trámite o cliente
  useEffect(() => onEntidadChanged(() => fetchHoy()), []);

  // Automático: cualquier escritura en estas tablas (sin importar desde dónde
  // del programa) refresca el resumen. No requiere acordarse de emitir nada.
  useEffect(() => onDataChanged(() => fetchHoy(), ['expedientes', 'tramites', 'clientes', 'agenda', 'tareas']), []);

  async function completarTarea(id) {
    await supabase.from('tareas').update({ completada: true, completada_en: new Date().toISOString() }).eq('id', id);
    setTareasHoy(prev        => prev.filter(t => t.id !== id));
    setVencimientosHoy(prev  => prev.filter(t => t.id !== id));
    emitTareaChanged({ id, completada: true });
  }

  // Completa la tarea y abre el modal de nueva tarea ya vinculada al mismo
  // expediente/trámite, para agendar el siguiente paso sin tener que volver
  // a buscarlo.
  function completarYAgendar(t) {
    completarTarea(t.id);
    setSeguimientoVinculo({ expediente_id: t.expediente_id || '', tramite_id: t.tramite_id || '' });
  }

  const fechaLabel = new Date().toLocaleDateString('es-AR', { weekday: 'long', day: 'numeric', month: 'long', year: 'numeric' });

  return (
    <div className="page">
      {/* Drawer Expediente */}
      {verExpediente && (
        <>
          <div className="drawer-overlay" onMouseDown={() => setVerExpediente(null)} />
          <div className="drawer">
            <ExpedienteDetalle expedienteId={verExpediente} onClose={() => setVerExpediente(null)} backLabel="← Espacio de trabajo" />
          </div>
        </>
      )}
      {verTramite && (
        <>
          <div className="drawer-overlay" onMouseDown={() => setVerTramite(null)} />
          <div className="drawer">
            <TramiteDetalle tramiteId={verTramite} onClose={() => setVerTramite(null)} backLabel="← Espacio de trabajo" />
          </div>
        </>
      )}

      {/* Drawer Cliente */}
      {verCliente && (
        <>
          <div className="drawer-overlay" onMouseDown={() => setVerCliente(null)} />
          <div className="drawer">
            <ClienteDetalle
              clienteId={verCliente}
              onClose={() => setVerCliente(null)}
              onEdit={(cliente) => { setClienteEdit(cliente); setVerCliente(null); }}
            />
          </div>
        </>
      )}

      <ClienteModal
        open={!!clienteEdit}
        editing={clienteEdit}
        onClose={() => setClienteEdit(null)}
        onSaved={() => setClienteEdit(null)}
      />

      {/* Topbar */}
      <div className="page-topbar">
        <div>
          <span className="page-title">Espacio de trabajo</span>
          <div style={{ fontSize: 12, color: 'var(--text4)', marginTop: 1, textTransform: 'capitalize' }}>{fechaLabel}</div>
        </div>
        <div style={{ display: 'flex', gap: 8 }}>
          <button className="btn btn-ghost btn-sm" onClick={() => setModalNuevoCliente(true)}>Nuevo Cliente</button>
          <button className="btn btn-ghost btn-sm" onClick={() => setModalNuevoExpTram(true)}>Nuevo Expediente / Trámite</button>
          <button className="btn btn-primary btn-sm" onClick={() => setModalNuevaTarea(true)}>+ Nueva tarea</button>
          <button className="btn btn-primary btn-sm" onClick={() => setModalNuevoEvento(true)}>+ Nuevo evento</button>
        </div>
      </div>

      {/* Drawer próximas audiencias */}
      {drawerAudiencias && (
        <>
          <div className="drawer-overlay" onMouseDown={() => setDrawerAudiencias(false)} />
          <div className="drawer drawer-wide">
            <div className="drawer-header">
              <div className="drawer-header-top">
                <div>
                  <div className="drawer-num">AGENDA</div>
                  <div className="drawer-title">Próximas audiencias y reuniones</div>
                </div>
                <button className="drawer-close" onClick={() => setDrawerAudiencias(false)}>✕</button>
              </div>
            </div>
            <div className="drawer-body">
              <AudienciasPanel
                mode="page"
                onOpenEdit={(ev) => { setDrawerAudiencias(false); setEventoDetalle(ev); }}
                onNavigateExpediente={(id) => { setDrawerAudiencias(false); setVerExpediente(id); }}
              />
            </div>
          </div>
        </>
      )}

      {/* Drawer próximas tareas con fecha */}
      {drawerTareas && (
        <>
          <div className="drawer-overlay" onMouseDown={() => setDrawerTareas(false)} />
          <div className="drawer drawer-wide">
            <div className="drawer-header">
              <div className="drawer-header-top">
                <div>
                  <div className="drawer-num">TAREAS</div>
                  <div className="drawer-title">Tareas con fecha</div>
                </div>
                <button className="drawer-close" onClick={() => setDrawerTareas(false)}>✕</button>
              </div>
            </div>
            <div className="drawer-body">
              <TareasPanel
                mode="page"
                onVerTarea={(t) => { setDrawerTareas(false); setTareaModal(t); }}
                onCompletar={async (id) => {
                  await supabase.from('tareas').update({ completada: true, completada_en: new Date().toISOString() }).eq('id', id);
                }}
                onNavigateExpediente={(id) => { setDrawerTareas(false); setVerExpediente(id); }}
                onNavigateTramite={(id) => { setDrawerTareas(false); setVerTramite(id); }}
              />
            </div>
          </div>
        </>
      )}

      {/* Drawer próximos vencimientos */}
      {drawerVencimientos && (
        <>
          <div className="drawer-overlay" onMouseDown={() => setDrawerVencimientos(false)} />
          <div className="drawer drawer-wide">
            <div className="drawer-header">
              <div className="drawer-header-top">
                <div>
                  <div className="drawer-num">AGENDA</div>
                  <div className="drawer-title">Próximos vencimientos</div>
                </div>
                <button className="drawer-close" onClick={() => setDrawerVencimientos(false)}>✕</button>
              </div>
            </div>
            <div className="drawer-body">
              <VencimientosPanel
                mode="page"
                onOpenEdit={(ev) => { setDrawerVencimientos(false); setEventoDetalle(ev); }}
                onVerTarea={(t) => { setDrawerVencimientos(false); setTareaModal(t); }}
                onNavigateExpediente={(id) => { setDrawerVencimientos(false); setVerExpediente(id); }}
              />
            </div>
          </div>
        </>
      )}

      {/* Drawer historial */}
      {drawerHistorial && (
        <>
          <div className="drawer-overlay" onMouseDown={() => setDrawerHistorial(false)} />
          <div className="drawer drawer-wide">
            <div className="drawer-header">
              <div className="drawer-header-top">
                <div>
                  <div className="drawer-num">ACTIVIDAD</div>
                  <div className="drawer-title">Registro de tareas y audiencias completadas</div>
                </div>
                <button className="drawer-close" onClick={() => setDrawerHistorial(false)}>✕</button>
              </div>
            </div>
            <div className="drawer-body">
              <HistorialPanel
                mode="page"
                onVerTarea={(t) => { setDrawerHistorial(false); setTareaModal(t); }}
                onOpenEdit={(ev) => { setDrawerHistorial(false); setEventoDetalle(ev); }}
                onNavigateExpediente={(id) => { setDrawerHistorial(false); setVerExpediente(id); }}
                onNavigateTramite={(id) => { setDrawerHistorial(false); setVerTramite(id); }}
              />
            </div>
          </div>
        </>
      )}

      <div className="page-content">
      <div style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>

        {/* Acceso rápido */}
        <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap', alignItems: 'flex-start' }}>

          {/* Próximas audiencias */}
          <div style={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
            <button className="btn btn-ghost btn-sm" onClick={() => setDrawerAudiencias(true)}
              style={{ borderLeft: '3px solid #0d9488', justifyContent: 'flex-start' }}>
              Próximas audiencias
            </button>
            {proximaAudiencia && (
              <div style={{ fontSize: 10, color: 'var(--text4)', paddingLeft: 10, display: 'flex', alignItems: 'center', gap: 5 }}>
                <span style={{ display: 'inline-block', width: 6, height: 6, borderRadius: '50%', background: '#0d9488', flexShrink: 0 }} />
                <span style={{ textTransform: 'capitalize' }}>
                  {new Date(proximaAudiencia.fecha + 'T12:00:00').toLocaleDateString('es-AR', { weekday: 'short', day: 'numeric', month: 'short' })}
                  {proximaAudiencia.hora ? ` · ${proximaAudiencia.hora.substring(0, 5)}` : ''}
                </span>
              </div>
            )}
          </div>

          {/* Próximos vencimientos */}
          <div style={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
            <button className="btn btn-ghost btn-sm" onClick={() => setDrawerVencimientos(true)}
              style={{ borderLeft: '3px solid #ea580c', justifyContent: 'flex-start' }}>
              Próximos vencimientos
            </button>
            {proximoVencimiento && (
              <div style={{ fontSize: 10, color: 'var(--text4)', paddingLeft: 10, display: 'flex', alignItems: 'center', gap: 5 }}>
                <span style={{ display: 'inline-block', width: 6, height: 6, borderRadius: '50%', background: '#ea580c', flexShrink: 0 }} />
                <span style={{ textTransform: 'capitalize' }}>
                  {new Date(proximoVencimiento.fecha_vencimiento + 'T12:00:00').toLocaleDateString('es-AR', { weekday: 'short', day: 'numeric', month: 'short' })}
                </span>
              </div>
            )}
          </div>

          {/* Próximas tareas */}
          <button className="btn btn-ghost btn-sm" onClick={() => setDrawerTareas(true)}
            style={{ borderLeft: '3px solid var(--blue)', justifyContent: 'flex-start' }}>
            Próximas tareas con fechas
          </button>

          {/* Historial */}
          <button className="btn btn-ghost btn-sm" onClick={() => setDrawerHistorial(true)}
            style={{ borderLeft: '3px solid #94a3b8', justifyContent: 'flex-start' }}>
            Registro de actividad
          </button>

        </div>

        {/* Fila principal: HOY + Tareas sin fecha */}
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 320px', gap: 14, alignItems: 'flex-start' }}>

          {/* HOY */}
          <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>

            {/* Vencimientos de hoy */}
            <Section title="Vencimientos de hoy" count={vencimientosEvHoy.length + vencimientosHoy.length} accentColor="#ea580c">
              {loading ? (
                <div style={{ color: 'var(--text4)', fontSize: 13 }}>Cargando…</div>
              ) : vencimientosEvHoy.length === 0 && vencimientosHoy.length === 0 ? (
                <div style={{ color: 'var(--text4)', fontSize: 13 }}>Sin vencimientos para hoy</div>
              ) : (
                <div style={{ display: 'flex', flexDirection: 'column', gap: 6, maxHeight: 300, overflowY: 'auto' }}>
                  {vencimientosEvHoy.map(ev => {
                    const cliente = ev.clientes ? `${ev.clientes.apellido || ''} ${ev.clientes.nombre || ''}`.trim() : ev.cliente_manual;
                    return (
                      <div key={'ev' + ev.id} onClick={() => setEventoDetalle(ev)}
                        style={{ padding: '9px 12px', background: 'var(--surface)', border: '0.5px solid var(--border)', borderRadius: 8, borderLeft: '3px solid #ea580c', display: 'flex', alignItems: 'center', gap: 12, cursor: 'pointer' }}>
                        <div style={{ flex: 1, minWidth: 0 }}>
                          <div style={{ fontSize: 13, fontWeight: 500, color: 'var(--text)' }}>{ev.titulo}</div>
                          <div style={{ display: 'flex', gap: 8, marginTop: 3, flexWrap: 'wrap', alignItems: 'center' }}>
                            <span style={{ fontSize: 10, fontWeight: 600, color: '#ea580c', background: '#ea580c18', padding: '1px 7px', borderRadius: 10 }}>{ev.tipo}</span>
                            {ev.expedientes && (
                              <span onClick={e => { e.stopPropagation(); setVerExpediente(ev.expediente_id); }} style={{ fontSize: 11, color: 'var(--blue)', cursor: 'pointer' }}>
                                {ev.expedientes.caratula?.substring(0, 30)}
                              </span>
                            )}
                            {cliente && <span style={{ fontSize: 11, color: 'var(--text3)' }}>{cliente}</span>}
                          </div>
                        </div>
                        {ev.hora && <span style={{ fontSize: 13, fontFamily: 'DM Mono', fontWeight: 600, color: '#ea580c', flexShrink: 0 }}>{formatHora(ev.hora)}</span>}
                      </div>
                    );
                  })}
                  {vencimientosHoy.map(t => {
                    const exp = t.expedientes?.caratula || t.tramites?.nombre;
                    return (
                      <div key={'ta' + t.id} onClick={() => setTareaModal(t)}
                        style={{ padding: '9px 12px', background: 'var(--surface)', border: '0.5px solid var(--border)', borderRadius: 8, borderLeft: '3px solid #ea580c', display: 'flex', gap: 10, alignItems: 'flex-start', cursor: 'pointer' }}>
                        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 4, flexShrink: 0, marginTop: 2 }}>
                          <input type="checkbox"
                            onClick={e => e.stopPropagation()}
                            onChange={() => completarTarea(t.id)} />
                          <button type="button"
                            title="Completar y agendar la próxima tarea para este expediente/trámite"
                            onClick={e => { e.stopPropagation(); completarYAgendar(t); }}
                            style={{ width: 16, height: 16, padding: 0, lineHeight: 1, fontSize: 11, fontWeight: 700, borderRadius: 4, border: '1px solid var(--border2)', background: 'var(--surface2)', color: 'var(--text4)', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                            +
                          </button>
                        </div>
                        <div style={{ flex: 1, minWidth: 0 }}>
                          <div style={{ fontSize: 13, fontWeight: 500, color: 'var(--text)' }}>{t.titulo}</div>
                          {exp && (
                            <span onClick={e => { e.stopPropagation(); if (t.expediente_id) setVerExpediente(t.expediente_id); else if (t.tramite_id) setVerTramite(t.tramite_id); }}
                              style={{ fontSize: 11, color: 'var(--blue)', cursor: 'pointer' }}>{exp.substring(0, 35)}</span>
                          )}
                        </div>
                        {t.prioridad === 'urgente' && <span style={{ fontSize: 10, background: '#fee2e2', color: 'var(--red)', padding: '1px 6px', borderRadius: 8, flexShrink: 0 }}>Urgente</span>}
                      </div>
                    );
                  })}
                </div>
              )}
            </Section>

            {/* Audiencias de hoy */}
            <Section title="Audiencias de hoy" count={audienciasHoy.length} accentColor="#0d9488">
              {loading ? (
                <div style={{ color: 'var(--text4)', fontSize: 13 }}>Cargando…</div>
              ) : audienciasHoy.length === 0 ? (
                <div style={{ color: 'var(--text4)', fontSize: 13 }}>Sin audiencias para hoy</div>
              ) : (
                <div style={{ display: 'flex', flexDirection: 'column', gap: 6, maxHeight: 300, overflowY: 'auto' }}>
                  {audienciasHoy.map(ev => {
                    const color   = colorTipo(ev.tipo);
                    const cliente = ev.clientes ? `${ev.clientes.apellido || ''} ${ev.clientes.nombre || ''}`.trim() : ev.cliente_manual;
                    return (
                      <div key={ev.id} onClick={() => setEventoDetalle(ev)}
                        style={{ padding: '9px 12px', background: 'var(--surface)', border: '0.5px solid var(--border)', borderRadius: 8, borderLeft: `3px solid ${color}`, display: 'flex', alignItems: 'center', gap: 12, cursor: 'pointer' }}>
                        <div style={{ flex: 1, minWidth: 0 }}>
                          <div style={{ fontSize: 13, fontWeight: 500, color: 'var(--text)' }}>{ev.titulo}</div>
                          <div style={{ display: 'flex', gap: 8, marginTop: 3, flexWrap: 'wrap', alignItems: 'center' }}>
                            <span style={{ fontSize: 10, fontWeight: 600, color, background: color + '18', padding: '1px 7px', borderRadius: 10 }}>{ev.tipo}</span>
                            {ev.expedientes && (
                              <span onClick={e => { e.stopPropagation(); setVerExpediente(ev.expediente_id); }} style={{ fontSize: 11, color: 'var(--blue)', cursor: 'pointer' }}>
                                {ev.expedientes.caratula?.substring(0, 30)}
                              </span>
                            )}
                            {cliente && <span style={{ fontSize: 11, color: 'var(--text3)' }}>{cliente}</span>}
                          </div>
                        </div>
                        {ev.hora && (
                          <span style={{ fontSize: 13, fontFamily: 'DM Mono', fontWeight: 600, color, flexShrink: 0 }}>{formatHora(ev.hora)}</span>
                        )}
                      </div>
                    );
                  })}
                </div>
              )}
            </Section>

            {/* Tareas de hoy */}
            <Section title="Tareas de hoy" count={tareasHoy.length} accentColor="var(--blue)">
              {loading ? (
                <div style={{ color: 'var(--text4)', fontSize: 13 }}>Cargando…</div>
              ) : tareasHoy.length === 0 ? (
                <div style={{ color: 'var(--text4)', fontSize: 13 }}>Sin tareas para hoy</div>
              ) : (
                <div style={{ display: 'flex', flexDirection: 'column', gap: 6, maxHeight: 300, overflowY: 'auto' }}>
                  {tareasHoy.map(t => {
                    const exp = t.expedientes?.caratula || t.tramites?.nombre;
                    return (
                      <div key={t.id} onClick={() => setTareaModal(t)}
                        style={{ padding: '9px 12px', background: 'var(--surface)', border: '0.5px solid var(--border)', borderRadius: 8, display: 'flex', gap: 10, alignItems: 'flex-start', cursor: 'pointer' }}>
                        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 4, flexShrink: 0, marginTop: 2 }}>
                          <input type="checkbox"
                            onClick={e => e.stopPropagation()}
                            onChange={() => completarTarea(t.id)} />
                          <button type="button"
                            title="Completar y agendar la próxima tarea para este expediente/trámite"
                            onClick={e => { e.stopPropagation(); completarYAgendar(t); }}
                            style={{ width: 16, height: 16, padding: 0, lineHeight: 1, fontSize: 11, fontWeight: 700, borderRadius: 4, border: '1px solid var(--border2)', background: 'var(--surface2)', color: 'var(--text4)', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                            +
                          </button>
                        </div>
                        <div style={{ flex: 1, minWidth: 0 }}>
                          <div style={{ fontSize: 13, fontWeight: 500, color: 'var(--text)' }}>{t.titulo}</div>
                          {exp && (
                            <span onClick={e => { e.stopPropagation(); if (t.expediente_id) setVerExpediente(t.expediente_id); else if (t.tramite_id) setVerTramite(t.tramite_id); }}
                              style={{ fontSize: 11, color: 'var(--blue)', cursor: 'pointer' }}>{exp.substring(0, 35)}</span>
                          )}
                        </div>
                        {t.prioridad === 'urgente' && <span style={{ fontSize: 10, background: '#fee2e2', color: 'var(--red)', padding: '1px 6px', borderRadius: 8, flexShrink: 0 }}>Urgente</span>}
                      </div>
                    );
                  })}
                </div>
              )}
            </Section>

          </div>

          {/* Tareas pendientes sin fecha (inbox) */}
          <div style={{ background: 'var(--surface)', border: '1px solid var(--border2)', borderRadius: 10, overflow: 'hidden' }}>
            <div style={{ padding: '10px 14px', background: 'var(--surface2)', borderBottom: '1px solid var(--border2)', display: 'flex', alignItems: 'center', gap: 8 }}>
              <div style={{ width: 3, height: 14, borderRadius: 2, background: '#64748b', flexShrink: 0 }} />
              <span style={{ fontSize: 12, fontWeight: 700, color: 'var(--text)', textTransform: 'uppercase', letterSpacing: 0.5 }}>Tareas pendientes</span>
              <span style={{ fontSize: 11, color: 'var(--text4)', background: 'var(--surface)', border: '1px solid var(--border2)', borderRadius: 10, padding: '0 7px' }}>{tareasPendientesCount}</span>
              <input
                type="text"
                placeholder="Buscar…"
                value={buscarTarea}
                onChange={e => setBuscarTarea(e.target.value)}
                style={{ marginLeft: 'auto', width: 120, fontSize: 11, padding: '2px 8px', border: '1px solid var(--border)', borderRadius: 6, background: 'var(--surface)', color: 'var(--text)', outline: 'none' }}
              />
            </div>
            <div style={{ maxHeight: 460, overflowY: 'auto' }}>
              <TareasPanel
                mode="widget"
                limit={20}
                buscar={buscarTarea}
                onCount={setTareasPendientesCount}
                onVerTarea={setTareaModal}
                onCompletar={async (id) => {
                  const { error } = await supabase.from('tareas').update({ completada: true, completada_en: new Date().toISOString() }).eq('id', id);
                  if (error) alert('Error al guardar: ' + error.message);
                  setTareasHoy(prev => prev.filter(t => t.id !== id));
                  setVencimientosHoy(prev => prev.filter(t => t.id !== id));
                }}
                onNavigateExpediente={setVerExpediente}
                onNavigateTramite={setVerTramite}
              />
            </div>
          </div>
        </div>


      </div>{/* end wrapper flex column */}
      </div>{/* end page-content */}

      {/* Modal ficha tarea */}
      {tareaModal && (
        <TareaDetalle
          tareaId={tareaModal.id}
          onClose={() => setTareaModal(null)}
          onCompletar={() => { setTareaModal(null); fetchHoy(); }}
          onEdit={(tarea) => { setTareaModal(null); setTareaEdit(tarea); }}
          onNavigateExpediente={(id) => { setVerExpediente(id); setTareaModal(null); }}
          onNavigateTramite={(id)   => { setVerTramite(id);    setTareaModal(null); }}
        />
      )}

      {/* Modal ficha evento */}
      {eventoDetalle && (
        <EventoDetalle
          eventoId={eventoDetalle.id}
          onClose={() => setEventoDetalle(null)}
          onEdit={(ev) => { setEventoEdit(ev); setEventoDetalle(null); }}
          onNavigateExpediente={(id) => { setVerExpediente(id); setEventoDetalle(null); }}
          onNavigateTramite={(id)  => { setVerTramite(id);  setEventoDetalle(null); }}
          onNavigateCliente={(id)  => { setVerCliente(id);  setEventoDetalle(null); }}
          onChanged={fetchHoy}
        />
      )}

      {/* Modal edición evento */}
      <EventoModal
        open={!!eventoEdit}
        editing={eventoEdit}
        onClose={() => setEventoEdit(null)}
        onSaved={fetchHoy}
      />

      {/* Modal nuevo evento */}
      <EventoModal
        open={modalNuevoEvento}
        editing={null}
        onClose={() => setModalNuevoEvento(false)}
        onSaved={() => { setModalNuevoEvento(false); fetchHoy(); }}
      />

      {/* Modal nueva tarea */}
      <TareaModal
        open={modalNuevaTarea}
        onClose={() => setModalNuevaTarea(false)}
        onSaved={() => { setModalNuevaTarea(false); fetchHoy(); }}
      />

      {/* Modal edición tarea */}
      <TareaModal
        open={!!tareaEdit}
        editing={tareaEdit}
        onClose={() => setTareaEdit(null)}
        onSaved={() => { setTareaEdit(null); fetchHoy(); }}
      />

      {/* Modal agendar tarea de seguimiento (al completar y agendar) */}
      <TareaModal
        open={!!seguimientoVinculo}
        defaultExpedienteId={seguimientoVinculo?.expediente_id}
        defaultTramiteId={seguimientoVinculo?.tramite_id}
        onClose={() => setSeguimientoVinculo(null)}
        onSaved={() => { setSeguimientoVinculo(null); fetchHoy(); }}
      />

      {/* Modal Nuevo Cliente */}
      <ClienteModal
        open={modalNuevoCliente}
        onClose={() => setModalNuevoCliente(false)}
        onSaved={() => setModalNuevoCliente(false)}
      />

      {/* Modal elegir Expediente o Trámite */}
      {modalNuevoExpTram && !nuevoExpTramTipo && (
        <div className="modal-overlay" onMouseDown={e => e.target === e.currentTarget && setModalNuevoExpTram(false)}>
          <div className="modal" style={{ width: 420 }}>
            <div className="modal-header">
              <div className="modal-title">¿Qué querés crear?</div>
              <button className="modal-close" onClick={() => setModalNuevoExpTram(false)}>✕</button>
            </div>
            <div className="modal-body" style={{ display: 'flex', gap: 12, padding: '20px 24px' }}>
              <button
                onClick={() => setNuevoExpTramTipo('expediente')}
                style={{ flex: 1, padding: '18px 12px', border: '1px solid var(--border2)', borderRadius: 10, background: 'var(--surface2)', cursor: 'pointer', textAlign: 'center', fontSize: 14, fontWeight: 600, color: 'var(--text)' }}
              >
                <div style={{ fontSize: 28, marginBottom: 6 }}>📁</div>
                Nuevo Expediente
              </button>
              <button
                onClick={() => setNuevoExpTramTipo('tramite')}
                style={{ flex: 1, padding: '18px 12px', border: '1px solid var(--border2)', borderRadius: 10, background: 'var(--surface2)', cursor: 'pointer', textAlign: 'center', fontSize: 14, fontWeight: 600, color: 'var(--text)' }}
              >
                <div style={{ fontSize: 28, marginBottom: 6 }}>📋</div>
                Nuevo Trámite Extrajudicial
              </button>
            </div>
          </div>
        </div>
      )}

      {nuevoExpTramTipo === 'expediente' && (
        <ExpedienteNuevoModal
          open
          onClose={() => { setNuevoExpTramTipo(null); setModalNuevoExpTram(false); }}
          onSaved={() => { setNuevoExpTramTipo(null); setModalNuevoExpTram(false); }}
        />
      )}

      {nuevoExpTramTipo === 'tramite' && (
        <TramiteNuevoModal
          open
          onClose={() => { setNuevoExpTramTipo(null); setModalNuevoExpTram(false); }}
          onSaved={() => { setNuevoExpTramTipo(null); setModalNuevoExpTram(false); }}
        />
      )}
    </div>
  );
}
